module.exports = __webpack_public_path__ + "img/number.a294ba3c.png";